const Strings = {
    USERNAME: "Username",
    PASSWORD: "Password",
    LOGIN: "Login",
    FORGOT_PASSWORD: "Forgot your password?",
    USER_PROFILE_ALT: "user",
    DUMMY_PROFILE_PIC: "https://www.wrappixel.com/demos/admin-templates/materialpro-bootstrap-latest/material-pro/src/assets/images/users/1.jpg",
    PROFILE_TITLE: "My Profile",
    BALANCE_TITLE: "My Balance",
    INBOX_TITLE: "Inbox",
    ACCOUNT_SETTINGS_TITLE: "Account Settings",
    LOGOUT_TITLE: "Logout",
    MENU_USER_TITLE: "Users",
    MENU_PROFILES_TITLE: "Profiles",
    MENU_GROUPS_TITLE: "Groups",
    MENU_LOCATIONS_TITLE: "Locations",
    MENU_PROGRAMS_TITLE: "Programs",
    MENU_CARDHOLDERS_TITLE: "Cardholders",
    MENU_PROMOTIONS_TITLE: "Promotions",
    MENU_REPORTS_TITLE: "Reports",
    COLUMN_USER_TITLE: "Users",
    COLUMN_USER_NAME: "User Name",
    COLUMN_USER_PROFILE: "Profile",
    COLUMN_USER_DELETE_TEXT: "Are you sure you want to delete this user?",
    COLUMN_DOB: "DOB",
    COLUMN_GROUP: "Group",
    COLUMN_SHORT_DESCRIPTION: "IVR description",
    COLUMN_LOCATION: "Location",
    COLUMN_STATUS: "Status",
    COLUMN_PROFILE_TITLE: "Profiles",
    COLUMN_PROFILE_NAME: "Profile Name",
    COLUMN_PROFILE_DESCRIPTION: "Description",
    COLUMN_PROFILE_DELETE_TEXT: "Are you sure you want to delete this profile?",
    COLUMN_CARD_TITLE: "Cardholders",
    COLUMN_CARD_FULLNAME: "Full Name",
    COLUMN_CARD_FIRSTNAME: "First Name",
    COLUMN_CARD_LASTNAME: "Last Name",
    COLUMN_CARD_NUMBER: "Card Number",
    COLUMN_CARD_TELEPHONE: "Telephone",
    COLUMN_PROMOTION_TITLE_DETAILS: "Title",
    COLUMN_PROMOTION_DESCRIPTION: "Description",
    COLUMN_PROMOTION_TITLE: "Promotions",
    COLUMN_PROMOTION_START: "Start",
    COLUMN_PROMOTION_END: "End",
    COLUMN_PROMOTION_PRIORITY: "Priority",
    COLUMN_PROMOTION_PUSH: "Push",
    COLUMN_PROMOTION_DELETE_TEXT: "Are you sure you want to delete this promotion?",
    COLUMN_GROUP_DELETE_TEXT: "Are you sure you want to delete this group?",
    COLUMN_LOCATION_DELETE_TEXT: "Are you sure you want to delete this location?",
    COLUMN_PROGRAM_DESCRIPTION: "Description",
    COLUMN_PROGRAM_TITLE: "Programs",
    SEARCH: "Search",
    SEARCH_USER_TILTLE: "Search User",
    SEARCH_CASINO_GROUP: "Select Casino Group",
    SEARCH_CASINO_LOCATION: "Select Casino Location",
    SEARCH_DATE: "MM/dd/YYYY",
    SEARCH_PROFILE_TILTLE: "Search Profile",
    SEARCH_GROUPS_TITLE: "Search Group",
    SEARCH_LOCATIONS_TITLE: "Search Location",
    SEARCH_CARDHOLDERS_TITLE: "Search Cardholder",
    SEARCH_PROMOTIONS_TITLE: "Search Promotion",
    SEARCH_PROGRAM_TITLE: "Search Program",
    CARD_NUMBER_LABEL: "Enter account/first or last name",
    START_DATE_LABEL: "Select Start Date",
    DATE_RANGE: "Select Date Range",
    END_DATE_LABEL: "Select End Date",
    START_DATE_TIME_LABEL: "Select Start Date Time",
    END_DATE_TIME_LABEL: "Select End Date Time",
    EMAIL: "Email:",
    TELEPHONE: "Telephone:",
    ADDRESS: "Address:",
    DATEOFBIRTH: "Date of birth:",
    DRIVERSLICENSE: "Drivers License:",
    PREVIOUSTRANSACTIONS: "Previous Transactions",
    BALEYS: "Baley's",
    STRIP: "Strip",
    SILVERPROGRAM: "Silver Program",
    SUSPEND: "Suspend",
    UNSUSPEND: "Unsuspend",
    PINCHANGE: "PIN Change",
    REPLACE: "Replace",
    ZENDESK: "Zendesk",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    DATE: "Date",
    AMOUNT: "Amount",
    TYPE: "Type",
    ACCOUNT: "Account",
    STATUS: "Status",
    BACK_TO_CARDHOLDERS: "Back to CardHolders",
    MORE: "More",
    SEARCH_OTHER_PROGRAM: "Other Program",
    SEARCH_OTHER_GROUP: "Other Group",
    SEARCH_OTHER_LOCATION: "Other Location",
    NO_GROUP: "No Group",
    NO_LOCATION: "No Location",
    SUPERADMIN: "SUPERADMIN",
    SEARCH_COUNTRY: "Select Country",
    SEARCH_STATE: "Select State",
    SEARCH_TELEPHONETYPE: "Select Telephone Type",
    ZENDESK_TICKET_CREATE: "Create Ticket",
    ZENDESK_TICKET_VIEW: "View Ticket",
    SESSION_TITLE: "Session Timeout",
    SESSION_CONTENT_HEADER: "Your current session is going to expire soon!",
    SESSION_CONTENT_FOOTER: "Would you like to continue the session?",
    REMAINING: "Remaining",
    SECONDS: "Seconds",
    CONTINUE_SESSION: "Continue Session",
    PHONE_NUMBER: "Phone Number",
    PHONE_TYPE: "Phone Type",
    PREFFERED: "Is Preffered",
    EMAIL_TEXT: "Email",
    CARD_ADDRESSLINE: "Address Line",
    CARD_ADDRESSTYPE: "Address Type",
    CARD_BETWEENSTREETS: "Between Streets",
    CARD_CITY: "City",
    CARD_COLONY: "Colony",
    CARD_COMMENT: "Comment",
    CARD_COUNTRY: "Country",
    CARD_INTERIOR: "Interior",
    CARD_MUNICIPALITY: "Municipality",
    CARD_HOME_NUMBER: "Number",
    CARD_STATE: "State",
    CARD_STREET: "Street",
    CARD_ZIPCODE: "ZipCode",
    TITLE: "Title",
    CARD_DESCRIPTION: "Description",
    TRAN_FROM_DATE: "From Date",
    TRAN_TO_DATE: "To Date",
    SEARCH_TRANSACTIONS_TITLE: "Search Transactions",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    MODULE: "Module",
    READ: "Read",
    CREATE: "Create",
    UPDATE: "Update",
    DELETE: "Delete",
    SPECIAL: "Special",
    ENDPOINT_HEADING: "Available Routes",
    ACCESS_DENIED: "Access Denied",
    ACCESS_DENIED_DESC: "You don't have necessary permission to view the content of this page. Contact your administrator for further support.",
    IMG_CASINO_LOGO_SMALL: '../img/casino_small_logo.png',
    IMG_MASTER_CARD_LOGO: '../img/card1.jpg',
    IMG_MAIN_CARD_LOGO: '../img/main_card_logo.png',
    OL_CURRENT_BALANCE_TITLE: 'Open Loop Balance',
    CL_CURRENT_BALANCE_TITLE: 'Close Loop Balance',
    CARD_ORDERBY_FIRSTNAME: 'first_name',
    CARD_ORDERBY_LASTNAME: 'last_name',
    CARD_ORDERBY_GROUPDESCRIPTION: 'group_description',
    CARD_ORDERBY_DATEOFBIRTH: 'date_of_birth',
    CARD_ORDERBY_PHONENUMBER: 'phone_number',
    CARD_ORDERBY_MERCHANT: 'merchant',
    CARD_STATUS_CHANGE_SUCCESS: 'Status updated successfully!',
    CARD_STATUS_CHANGE_FAIL: 'Status not updated! Please try again',
    CARD_STATUS_CHANGE_REASON: 'Status updated',
    PROGRAM: 'PROGRAM',
    LOCATION: 'LOCATION',
    GROUP: 'GROUP',
    CARD:'CARD NUMBER'


}
export { Strings }